module.exports = __webpack_public_path__ + "img/db.219e0858.jpg";